import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faAt, faCalendarAlt, faDollarSign, faHashtag, faSave, faTimes, faUsers } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        invoice_date: '',
        paid_type: '',
        invoice_total: 0,
        invoice_remaining: 0,
        details: '',
        customer_id: '',
        customer_name: '',
        customer_address: '',
        customer_phone: '',
        quotation_id: '',
        sub_total: 0,
        taxes: 0,
        discounts: 0,
        total: 0,
        max: 0,
        quotation_invoice_remaining: 0,
        invoice_id: '',
        readOnly: false,
        invoiceRemaining: false,
        quotationInvoiceRemaining: false,
        customers: [],
        quotations: [],
        quotationData: [],
        quotationItems: [],
        errors: [],
    }
    sessionExpired = () => {
        Swal.fire('Token has Expired!', 'Re-Login', 'info');
        window.localStorage.clear();
        window.location.href = '/';
    }
    changeValue = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errors: [] })
    }
    errorVerify(element) {
        return this.state.errors.indexOf(element) !== -1;
    }
    sendData = async (e) => {
        e.preventDefault();
        const { customer_id, quotation_id, invoice_date, paid_type, invoice_total, invoice_remaining, details } = this.state;
        var errors = [];
        if (!customer_id) { errors.push("error_customer_id"); }
        if (!quotation_id) { errors.push("error_quotation_id"); }
        if (!invoice_date) { errors.push("error_invoice_date"); }
        if (!paid_type) { errors.push("error_paid_type"); }
        if (!invoice_total) { errors.push("error_invoice_total"); }
        if (paid_type === 2) {
            if (!invoice_remaining) { errors.push("error_invoice_remaining"); }
        }
        console.log(errors.length);
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        var dataInvoice = {
            customer_id: customer_id,
            quotation_id: quotation_id,
            invoice_date: invoice_date,
            paid_type: paid_type,
            invoice_total: invoice_total,
            invoice_remaining: invoice_remaining,
            details: details,
            user_id: window.localStorage.getItem('idusuario')
        }
        try {
            Swal.fire({
                title: 'Saving...',
                text: 'Please, wait',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
            const invoicesDataRes = await authAxios.post("invoices/register", dataInvoice);
            if (!invoicesDataRes.data.status) {
                this.sessionExpired();
                return;
            }
            const { ID_INVOICE } = invoicesDataRes.data;
            const dataAccountsReceivable = {
                ...dataInvoice,
                id_invoice: ID_INVOICE
            }
            const accountsReceivableDataRes = await authAxios.post("accounts_receivable/register", dataAccountsReceivable)
            if (!accountsReceivableDataRes.data.status) {
                this.sessionExpired();
                return;
            }
            Swal.close();
            Swal.fire(
                'Invoices!',
                invoicesDataRes.data.msj,
                'success'
            );
            this.props.history.push("/UpInvoices/" + invoicesDataRes.data.ID_INVOICE);
        } catch (error) {
            console.error(error);
            Swal.close();
        }
    }
    selectCustomer = (customer_id, customer_name, customer_address, customer_phone) => {
        Swal.showLoading();
        this.setState({
            customer_id: '',
            customer_name: '',
            customer_address: '',
            customer_phone: '',
            quotation_id: '',
            quotations: [],
            quotationData: [],
            quotationItems: [],
            sub_total: 0,
            taxes: 0,
            discounts: 0,
            total: 0,
            max: 0
        });
        authAxios.get("invoices/quotations/" + customer_id)
            .then((dataResult) => {
                console.log(dataResult);
                var status = dataResult.data.status;
                if (status) {
                    Swal.fire('Token has Expired!', 'Re-Login', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({
                    quotations: dataResult.data,
                    customer_id: customer_id,
                    customer_name: customer_name,
                    customer_address: customer_address,
                    customer_phone: customer_phone
                });
                Swal.close();
            })
            .catch(console.log);
    }
    selectQuotation = (quotation_id) => {
        Swal.showLoading();
        this.setState({
            quotationData: [],
            quotationItems: [],
            sub_total: 0,
            taxes: 0,
            discounts: 0,
            total: 0,
            max: 0,
            quotation_invoice_remaining: 0,
            invoice_id: '',
            invoice_total: 0,
            invoice_remaining: 0,
            readOnly: false,
            invoiceRemaining: false,
            quotationInvoiceRemaining: false,
        });
        authAxios.get("invoices/quotation_info/" + quotation_id)
            .then((dataResult) => {
                Swal.showLoading();
                console.log(dataResult);
                if (dataResult.data.status) {
                    this.setState({
                        quotation_id: dataResult.data.quotation.ID_QUOTATION,
                        quotationData: dataResult.data.quotation,
                        quotationItems: dataResult.data.items,
                        sub_total: dataResult.data.sub_total,
                        taxes: dataResult.data.taxes,
                        discounts: dataResult.data.discounts,
                        total: dataResult.data.total,
                        max: dataResult.data.max,
                        quotation_invoice_remaining: dataResult.data.quotation_invoice_remaining,
                        invoice_id: dataResult.data.invoice_id,
                        quotationInvoiceRemaining: dataResult.data.quotation_invoice_remaining !== 0 ? true : false,
                    });
                } else {
                    this.setState({
                        quotationItems: [],
                        sub_total: 0
                    });
                }
                Swal.close();
            })
            .catch(console.log);
    }
    calculateTotal = (e) => {
        switch (e.target.value) {
            case '2':
                this.setState({
                    invoice_total: 0,
                    invoice_remaining: 0,
                    readOnly: false,
                    invoiceRemaining: true,
                })
                break;
            case '3':
                this.setState({
                    invoice_total: this.state.quotation_invoice_remaining === 0 ? this.state.total : this.state.total - this.state.quotation_invoice_remaining,
                    invoice_remaining: 0,
                    readOnly: true,
                    invoiceRemaining: false
                });
                break;
        }
    }
    calculateRemaining = (e) => {
        const invoice_total = e.target.value;
        const { total } = this.state;
        this.setState({
            invoice_remaining: total - invoice_total
        })
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("invoices/customers")
            .then((dataResult) => {
                console.log(dataResult);
                var status = dataResult.data.status;
                if (status) {
                    Swal.fire('Token has Expired!', 'Re-Login', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({
                    customers: dataResult.data
                });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const {
            invoice_date,
            paid_type,
            invoice_total,
            invoice_remaining,
            details,
            customer_id,
            customer_name,
            customer_address,
            customer_phone,
            quotation_id,
            sub_total,
            taxes,
            discounts,
            total,
            max,
            quotation_invoice_remaining,
            invoice_id,
            readOnly,
            invoiceRemaining,
            quotationInvoiceRemaining,
            customers,
            quotations,
            quotationData,
            quotationItems
        } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>NEW INVOICE</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.sendData}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <hr style={{ marginBottom: 0, marginTop: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INVOICE INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="invoice_id">Invoice ID.</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" name="invoice_id" id="invoice_id" 
                                                            className="form-control form-control-sm" placeholder="Invoice ID." aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-md-6"></div>
                                                <div className="col-md-2">
                                                    <label htmlFor="invoice_date">Invoice Date</label>
                                                    <div className={((this.errorVerify("error_invoice_date")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="invoice_date" id="invoice_date" value={invoice_date}
                                                            className={((this.errorVerify("error_invoice_date")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Invoice Date" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please choose Invoice Date</small>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="invoice_status">Status</label>
                                                    <input style={{ textTransform: 'uppercase', color: "#FFFFFF", backgroundColor: "#00539B", fontWeight: "bold" }} type="text" name="invoice_status" id="invoice_status" value="IN PROCESS"
                                                        className="form-control form-control-sm text-center" placeholder="Status" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-12">
                                                    <label htmlFor="details">Other Comments</label>
                                                    <textarea style={{ resize: 'none', textTransform: 'uppercase' }}
                                                        className='form-control form-control-sm' id="details" name="details" rows='3' value={details}
                                                        onChange={this.changeValue} aria-describedby="helpId"></textarea>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>CUSTOMER INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-2'>
                                                    <label htmlFor="customer_id">Customer ID.</label>
                                                    <div className={((this.errorVerify("error_customer_id")) ? "is-invalid" : "") + " btn-group"} role="group" aria-label="">
                                                        <button type="button" className="btn btn-primary btn-sm" data-bs-toggle='modal' data-bs-target="#CustomersModal" slot='end'>
                                                            <FontAwesomeIcon icon={faUsers} />
                                                        </button>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="customer_id" id="customer_id" value={customer_id} 
                                                            className={((this.errorVerify("error_customer_id")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Customer ID." aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please choose Customer</small>
                                                </div>
                                                <div className='col-md-4'>
                                                    <label htmlFor="customer_name">Customer Name</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="customer_name" id="customer_name" value={customer_name}
                                                        className="form-control form-control-sm" placeholder="Customer Name" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className='col-md-4'>
                                                    <label htmlFor="customer_address">Customer Address</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="customer_address" id="customer_address" value={customer_address}
                                                        className="form-control form-control-sm" placeholder="Customer Address" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="customer_phone">Customer Phone</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="customer_phone" id="customer_phone" value={customer_phone}
                                                            className="form-control form-control-sm" placeholder="Customer Phone" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Customer Phone</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>QUOTATION INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-2'>
                                                    <label htmlFor="quotation_id">Quotation ID.</label>
                                                    <div className={((this.errorVerify("error_quotation_id")) ? "is-invalid" : "") + " btn-group"} role="group" aria-label="">
                                                        <button type="button" className="btn btn-primary btn-sm" data-bs-toggle='modal' data-bs-target="#QuotationsModal" slot='end'>
                                                            <FontAwesomeIcon icon={faHashtag} />
                                                        </button>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="quotation_id" id="quotation_id" defaultValue={quotationData.ID_QUOTATION} 
                                                            className={((this.errorVerify("error_quotation_id")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Quotation ID." aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please choose Quotation</small>
                                                </div>
                                                <div className="col-md-4"></div>
                                                <div className="col-md-2">
                                                    <label htmlFor="quotation_date">Quotation Date</label>
                                                    <div className={((this.errorVerify("error_quotation_date")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="quotation_date" id="quotation_date" defaultValue={quotationData.QUOTATION_DATE}
                                                            className={((this.errorVerify("error_quotation_date")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Quotation Date" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please choose Quotation Date</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="due_date">Due Date</label>
                                                    <div className={((this.errorVerify("error_due_date")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="due_date" id="due_date" defaultValue={quotationData.DUE_DATE}
                                                            className={((this.errorVerify("error_due_date")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Due Date" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please choose Due Date</small>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="quotation_status">Status</label>
                                                    <input type="text" name="quotation_status" id="quotation_status"
                                                        defaultValue={
                                                            quotationData.STATUS === 1 ? "IN PROCESS" :
                                                            quotationData.STATUS === 2 ? "APPROVED" :
                                                            quotationData.STATUS === 3 ? "CANCELED" : ""
                                                        }
                                                        style={{
                                                            textTransform: 'uppercase',
                                                            color: "#FFFFFF",
                                                            fontWeight: "bold",
                                                            backgroundColor:
                                                                quotationData.STATUS === 1 ? "#00539B" :
                                                                quotationData.STATUS === 2 ? "#198754" :
                                                                quotationData.STATUS === 3 ? "#DC3545" : ""
                                                        }}
                                                        className="form-control form-control-sm text-center" placeholder="Status" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-12">
                                                    <label htmlFor="quotation_details">Other Comments</label>
                                                    <textarea style={{ resize: 'none', textTransform: 'uppercase' }}
                                                        className='form-control form-control-sm' id="quotation_details" name="quotation_details" rows='3' defaultValue={quotationData.DETAILS}
                                                        onChange={this.changeValue} aria-describedby="helpId" readOnly></textarea>
                                                </div>
                                            </div>
                                            <hr />
                                            <div className='row g-3'>
                                                <div className="col-xl-12">
                                                    <table className="table table-hover table-condensed table-sm">
                                                        <thead className="thead-inverse">
                                                            <tr>
                                                                <th className="align-middle">DESCRIPTION</th>
                                                                <th className="align-middle">HUD #</th>
                                                                <th className="align-middle">AMOUNT</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                quotationItems.map((itemArrayResult) => (
                                                                    <tr key={itemArrayResult.ID_QUOT_ITEM}>
                                                                        <td>{itemArrayResult.DESCRIPTION}</td>
                                                                        <td>{itemArrayResult.HUD_NUMBER}</td>
                                                                        <td><b>$ </b>{currencyFormat(itemArrayResult.AMOUNT)}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>PAYMENT INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="sub_total">Sub Total</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="sub_total" id="sub_total" value={sub_total}
                                                            className="form-control form-control-sm" placeholder="Sub Total" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="taxes">Taxes</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="taxes" id="taxes" value={taxes}
                                                            className="form-control form-control-sm" placeholder="Taxes" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="discounts">Discounts</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="discounts" id="discounts" value={discounts}
                                                            className="form-control form-control-sm" placeholder="Discounts" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4"></div>
                                                <div className="col-md-2">
                                                    <label htmlFor="total">Quotation Total</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="total" id="total" value={total}
                                                            className="form-control form-control-sm" placeholder="Total" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                quotationInvoiceRemaining ?
                                                    <div style={{ marginTop: 0 }} className='row g-3'>
                                                        <div className="col-md-10"></div>
                                                        <div className="col-md-2">
                                                            <label htmlFor="quotation_invoice_remaining">Paid ({invoice_id})</label>
                                                            <div className={((this.errorVerify("error_quotation_invoice_remaining")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                                <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                                <input style={{ textTransform: 'uppercase' }} type="number" name="quotation_invoice_remaining" id="quotation_invoice_remaining" value={quotation_invoice_remaining}
                                                                    className={((this.errorVerify("error_quotation_invoice_remaining")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Paid" aria-describedby="helpId"
                                                                    onChange={this.changeValue} readOnly
                                                                />
                                                            </div>
                                                            <small id="helpId" className="invalid-feedback">Please enter Paid</small>
                                                        </div>
                                                    </div>
                                                : ''
                                            }
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-8"></div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="paid_type">Paid Type</label>
                                                    <select name="paid_type"
                                                        id="paid_type"
                                                        className={((this.errorVerify("error_paid_type")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={(e) => {
                                                            this.changeValue(e);
                                                            this.calculateTotal(e);
                                                        }}>
                                                        <option value="">SELECT PAID TYPE...</option>
                                                        {
                                                            quotation_invoice_remaining === 0 ?
                                                                <option value="2">PARTIAL PAID</option>
                                                            : ''
                                                        }
                                                        <option value="3">TOTAL PAID</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Please choose Paid Type</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="invoice_total">Total</label>
                                                    <div className={((this.errorVerify("error_invoice_total")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" max={max} name="invoice_total" id="invoice_total" value={invoice_total}
                                                            className={((this.errorVerify("error_invoice_total")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Invoice Total" aria-describedby="helpId"
                                                            onChange={(e) => {
                                                                this.changeValue(e);
                                                                this.calculateRemaining(e);
                                                            }}
                                                            readOnly={readOnly}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Invoice Total</small>
                                                </div>
                                            </div>
                                            {
                                                invoiceRemaining ?
                                                    <div style={{ marginTop: 0 }} className='row g-3'>
                                                        <div className="col-md-10"></div>
                                                        <div className="col-md-2">
                                                            <label htmlFor="invoice_remaining">Invoice Remaining</label>
                                                            <div className={((this.errorVerify("error_invoice_remaining")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                                <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                                <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" max={max} name="invoice_remaining" id="invoice_remaining" value={invoice_remaining}
                                                                    className={((this.errorVerify("error_invoice_remaining")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Invoice Remaining" aria-describedby="helpId"
                                                                    onChange={this.changeValue} readOnly
                                                                />
                                                            </div>
                                                            <small id="helpId" className="invalid-feedback">Please enter Invoice Remaining</small>
                                                        </div>
                                                    </div>
                                                : ''
                                            }
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Save</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterInvoices"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancel</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="CustomersModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="CustomersModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="CustomersModalLabel">Customers</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">CUSTOMER</th>
                                                    <th className="align-middle">ADDRESS</th>
                                                    <th className="align-middle">PHONE</th>
                                                    <th className="align-middle">CHOOSE</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    customers.map((itemCustomers) => (
                                                        <tr key={itemCustomers.ID_CUSTOMER }>
                                                            <td>{itemCustomers.NAME}</td>
                                                            <td>{itemCustomers.ADDRESS}</td>
                                                            <td>{itemCustomers.PHONE}</td>
                                                            <td>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-sm"
                                                                        data-bs-dismiss="modal"
                                                                        onClick={() =>
                                                                            this.selectCustomer(
                                                                                itemCustomers.ID_CUSTOMER,
                                                                                itemCustomers.NAME,
                                                                                itemCustomers.ADDRESS,
                                                                                itemCustomers.PHONE
                                                                            )
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="QuotationsModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="QuotationsModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="QuotationsModalLabel">Quotations</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">QUOTATION ID</th>
                                                    <th className="align-middle">QUOTATION DATE</th>
                                                    <th className="align-middle">DUE DATE</th>
                                                    <th className="align-middle">TOTAL</th>
                                                    <th className="align-middle">CHOOSE</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    quotations.map((itemQuotations) => (
                                                        <tr key={itemQuotations.ID_QUOTATION}>
                                                            <td>{itemQuotations.ID_QUOTATION}</td>
                                                            <td>{itemQuotations.QUOTATION_DATE}</td>
                                                            <td>{itemQuotations.DUE_DATE}</td>
                                                            <td><b>$ </b>{currencyFormat(itemQuotations.TOTAL)}</td>
                                                            <td>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-sm"
                                                                        data-bs-dismiss="modal"
                                                                        onClick={() =>
                                                                            this.selectQuotation(itemQuotations.ID_QUOTATION)
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;